import { useCallback, useState } from 'react';
import CSS from 'csstype';
import { TextInput, TextInputValue } from '../text-input/TextInput';
import Select from '../select/Select';
import RadioGroup from "../radio-group/RadioGroup";
import styles from './childForm.module.scss';
import IconRemove from '../../assets/icons/remove.svg?react';
import { useQueryDictionary } from '../../hooks/useQueryDictionary';
import { Children, SelectOption, InviteTypeEnum } from '../../types';

type Props = {
    id: number;
    child?: Children;
    color: CSS.Properties;
    onRemove: (index: number) => void;
    onChangeName?: (value: string) => void;
    onChangeEmail?: (value: string) => void;
    onSelectGrade?: (value: SelectOption) => void;
}

const emptyErrors = {
    firstName: '',
    email: '',
  };

export const options = [
    { label: "They will use my account", value: InviteTypeEnum.Parent },
    { label: "They will have their own login", value: InviteTypeEnum.Own }
]

function CreateChildProfile(props: Props) {
    const { id, child, color, onChangeName, onChangeEmail, onSelectGrade, onRemove } = props;

    const grades = useQueryDictionary({ dictionary: 'Grades' });
    const [grade, setGrade] = useState<string>();
    const [userType, setUserType] = useState<string>(InviteTypeEnum.Parent);
    const [errors, setErrors] = useState(emptyErrors);

    const handleChangeText = useCallback((setter, key: keyof typeof emptyErrors) => (value: TextInputValue) => {
        setErrors({
            ...errors,
            [key]: '',
        });
        setter(value)
    }, [errors]);

    const handleChangeSelect = useCallback((setter) => (o: SelectOption) => {
        setter(o);
        setGrade(o.value)
    }, []);

    const handleRemoveChild = () => {
        onRemove(id);
    };

    return (
        <>
            <div className={styles.userItem} style={color}>
                <div className={styles.childTitle}>
                    {child?.firstName.substring(0, 2) || '?'}
                </div>
                <div className={styles.removeItem} onClick={handleRemoveChild} >
                    <IconRemove />
                </div>
            </div>
            <TextInput className={styles.emailTitle} value={child?.firstName || ''}
                onChange={handleChangeText(onChangeName, 'firstName')} label={'First Name*'} id={'firstName'}
                placeholder={'First Name'} allowSpecialCharacters />
            <div className={styles.label}>Will Jenny be having her own profile, or logging in using your email address?</div>
            <div className={styles.emailTitle} >
                <RadioGroup
                    value={userType}
                    options={options}
                    onChange={(val) => setUserType(val)}
                    name={''}
                    hasError={false}
                    subTitle={""}
                />
            </div>
            { userType === InviteTypeEnum.Own &&
            <TextInput className={styles.emailTitle} label={'Email*'} value={child?.email || ''}
                onChange={handleChangeText(onChangeEmail, 'email')} id="email" allowSpecialCharacters />
            }
            <Select className={styles.selectionTitle} label={`Select {${child?.firstName}}'s Grade`} options={grades} onChange={handleChangeSelect(onSelectGrade)} value={grade} />
        </>
    )
};

export default CreateChildProfile;